import { ApplicationRef, Injectable, NgZone, inject } from '@angular/core';
import { fromEvent } from 'rxjs';
import i18next from 'i18next';



@Injectable({ providedIn: 'root' })
export class LanguageEventsService {
    private readonly zone = inject(NgZone);
    private readonly appRef = inject(ApplicationRef);


    constructor() {
        fromEvent<CustomEvent>(document, 'bahfLanguage').subscribe(ev => {
            const code =ev.detail?.activeLanguage?.code;
            if (!code) return;


            this.zone.run(() => {
                i18next
                    .changeLanguage(code)
                    .then(() => {
                        document.documentElement.lang = i18next.language;
                        this.appRef.tick();
                    })
                    .catch(err => console.error('[i18n] changeLanguage error:', err));
            });
        });
    }


    /** Optional: Header bitten, die aktuelle Sprache erneut zu senden */
    refreshFromHeader(): void {
        document.dispatchEvent(new CustomEvent('bahfSendLanguage'));
    }
}





